


































































import Vue, { PropType } from "vue";
// component
import HomeSmallCard from "@/features/home/components/homeSmallCard.vue";
import OverallTrendsCard from "@/features/home/components/overallTrendsCard.vue";
import DemandSalesCard from "@/features/home/components/demandSalesCard.vue";
import CPMTransitionCard from "@/features/home/components/cpmTransitionCard.vue";
// types
import {
  AdData,
  OverallTrends,
  OverallTrendsMaxAndMin,
  DemandSales,
  DemandSalesTable,
  CPMTransition,
} from "@/features/home/types";

export default Vue.extend({
  components: {
    "home-small-card": HomeSmallCard,
    "overall-trends-card": OverallTrendsCard,
    "demand-sales-card": DemandSalesCard,
    "cpm-transition-card": CPMTransitionCard,
  },
  props: {
    loading: { type: Boolean },
    estimatedRevenue: {
      type: Object as PropType<AdData>,
    },
    impression: {
      type: Object as PropType<AdData>,
    },
    ecpm: {
      type: Object as PropType<AdData>,
    },
    overallTrends: {
      type: Object as PropType<OverallTrends>,
    },
    demandSales: {
      type: Object as PropType<DemandSales>,
    },
    demandSalesTable: {
      type: Array as PropType<DemandSalesTable[]>,
    },
    cpmTransition: {
      type: Object as PropType<CPMTransition>,
    },
  },
  computed: {
    isNoOverallTrendsData(): boolean {
      return this.overallTrends.revenue.every(overallTrendsRevenue => {
        return overallTrendsRevenue === 0;
      });
    },
    isNoDemandSalesData(): boolean {
      return this.demandSales.revenue.every(demandSaleRevenue => {
        return demandSaleRevenue === 0;
      });
    },
    isNoCPMTransitionData(): boolean {
      return this.cpmTransition.cpm.every(cpm => {
        return cpm === null;
      });
    },
    hasOverallTrendsMissingData(): boolean {
      return (
        this.overallTrends.impression.some((imp: number) => imp === null) ||
        this.overallTrends.revenue.some((revenue: number) => revenue === null)
      );
    },
    hasCPMTransitionMissingData(): boolean {
      return (
        this.cpmTransition.avg.some((avg: number) => avg === null) ||
        this.cpmTransition.cpm.some((cpm: number) => cpm === null)
      );
    },
    overallTrendsMaxAndMin(): OverallTrendsMaxAndMin {
      return {
        revenue: {
          max: Math.max.apply(null, this.overallTrends.revenue),
          min: Math.min.apply(null, this.overallTrends.revenue),
        },
        impression: {
          max: Math.max.apply(null, this.overallTrends.impression),
          min: Math.min.apply(null, this.overallTrends.impression),
        },
      };
    },
  },
});
